module.exports = __webpack_public_path__ + "static/media/independence-day.d544dab4.svg";